export const toParam = sortOrder => {
  if (!sortOrder) return ''
  return `?sort=${encodeURIComponent(sortOrder)}`
}
